export default __webpack_public_path__ + "static/media/nhlbignew.e618f6bd.png";